
import { useTranslation } from "react-i18next";
import React, { useMemo } from "react";
import { Form, Col } from "react-bootstrap";
import FormGroup from "../../forms/FormGroup";
import Select from "../../forms/inputs/Select";
import DatePicker from "../../forms/inputs/DatePicker";
import CustomSwitch from "../../forms/inputs/CustomSwitch";
import Block from "../../Block";
import FormRowCol from "../../forms/FormRowCol";

const formGroupWidthProps = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6,
};

export function Main({ getInputProps, formRefValues, formData }) {
  const { t } = useTranslation();

  const groupedOptions = useMemo(
    () =>
      formRefValues.available_publishers.reduce((groups, item) => {
        const group = groups.find((g) => g.label === item.environment);
        const option = {
          value: item.id,
          label: item.name,
        };

        if (group) {
          group.options.push(option);
        } else {
          groups.push({
            label: item.environment,
            options: [option],
          });
        }

        return groups;
      }, []),
    [formRefValues.available_publishers],
  );

  return (
    <Block>
      <Form.Row>
        <FormGroup
          as={Col}
          {...formGroupWidthProps}
          label={t("dataVendor.name")}
          input="text"
          {...getInputProps("name")}
        />
        <FormGroup
          as={Col}
          {...formGroupWidthProps}
          label={t("dataVendor.bucket")}
          input="text"
          pre={`s3://data-stream-partners-sink/`}
          {...getInputProps("bucket")}
        />
      </Form.Row>
      <Form.Row>
        <FormGroup
          as={Col}
          {...formGroupWidthProps}
          label={t("dataVendor.environment")}
          placeholder={t("pleaseSelect")}
          {...getInputProps("environment")}
        >
          <Select>
            {formRefValues.environments.map((elt) => (
              <Option value={elt.id} key={`environment_${elt.id}`}>
                {elt.name}
              </Option>
            ))}
          </Select>
        </FormGroup>
        {formData.environment === "terminated" && (
          <FormGroup
            as={Col}
            input={DatePicker}
            {...formGroupWidthProps}
            label={t("dataVendor.terminated_at")}
            {...getInputProps("terminated_at")}
            placeholder={t("pleaseSelect")}
          />
        )}
        {formData.environment === "production" && (
          <FormGroup
            as={Col}
            input={DatePicker}
            {...formGroupWidthProps}
            label={t("dataVendor.billing_start_date")}
            {...getInputProps("billing_start_date")}
            placeholder={t("pleaseSelect")}
          />
        )}
      </Form.Row>
      <FormGroup
        as={FormRowCol}
        {...formGroupWidthProps}
        label={t("dataVendor.industry_id")}
        placeholder={t("pleaseSelect")}
        {...getInputProps("industry_id")}
      >
        <Select isClearable={true}>
          {formRefValues.industries.map((elt) => (
            <Option value={elt.id} key={`industry_id_${elt.id}`}>
              {elt.name}
            </Option>
          ))}
        </Select>
      </FormGroup>
      <FormGroup
        as={FormRowCol}
        {...formGroupWidthProps}
        input={CustomSwitch}
        label={t("dataVendor.isPublisher")}
        {...getInputProps("isPublisher")}
      />
      {formData.isPublisher && (
        <FormGroup
          as={FormRowCol}
          {...formGroupWidthProps}
          placeholder={t("dataVendor.selectPublisher")}
          {...getInputProps("publisher_id")}
        >
          <Select isClearable={true} options={groupedOptions}></Select>
        </FormGroup>
      )}
    </Block>
  );
}

export default Main;